import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Dropdown } from "semantic-ui-react";

const YearFilter = ({ selectedYear, onYearChange, availableYears }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const yearOptions = availableYears.map((year) => ({
    key: year,
    value: year,
    text: year.toString(),
    icon: "calendar",
  }));

  yearOptions.unshift({
    key: "all",
    value: null,
    text: "All Years",
    icon: "calendar outline",
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? "0.5rem" : "0.5rem",
        marginBottom: "0.5rem",
      }}
    >
      <span style={{ fontWeight: 500, fontSize: isMobile ? "0.9rem" : "1rem" }}>
        Filter by Year:
      </span>
      <Dropdown
        placeholder="Select Year"
        selection
        clearable
        options={yearOptions}
        value={selectedYear}
        onChange={(e, { value }) => onYearChange(value)}
        icon="calendar"
        fluid={isMobile}
        compact={!isMobile}
        style={{
          minWidth: isMobile ? "100%" : 120,
          maxWidth: isMobile ? "100%" : undefined,
        }}
      />
    </div>
  );
};

YearFilter.propTypes = {
  selectedYear: PropTypes.number,
  onYearChange: PropTypes.func.isRequired,
  availableYears: PropTypes.arrayOf(PropTypes.number).isRequired,
};

YearFilter.defaultProps = {
  selectedYear: null,
};

export default YearFilter;
